import React from 'react';
import './krysha.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import GuaranteeStrip from './components/GuaranteeStrip';
import AboutUs from './components/AboutUs';
import WhyHow from './components/WhyHow';
import Testimonials from './components/Testimonials';
import MatchmakingSection from './components/MatchmakingSection';
import Stats from './components/Stats';
import FAQ from './components/FAQ';
import BottomCTA from './components/BottomCTA';
import Footer from './components/Footer';
import AdminPage from './pages/AdminPage';
import TermsPage from './pages/TermsPage';
import AuthPage from './pages/AuthPage';
import DashboardPage from './pages/DashboardPage';
import ConnectPage from './pages/ConnectPage';
import InboxPage from './pages/InboxPage';
import ProfilePage from './pages/ProfilePage';
import PreferencesPage from './pages/PreferencesPage';
import MyFormPage from './pages/MyFormPage';
import SettingsPage from './pages/SettingsPage';
import MemberProfilePage from './pages/MemberProfilePage';
import ScrollToTop from './components/ScrollToTop';

const Landing = () => (
  <>
    <Navbar />
    <Hero />
    <GuaranteeStrip />
    <AboutUs />
    <WhyHow />
    <Testimonials />
    <MatchmakingSection />
    <Stats />
    <FAQ />
    <BottomCTA />
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/inbox" element={<InboxPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/match-preferences" element={<PreferencesPage />} />
          <Route path="/my-form" element={<MyFormPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/member/:kryshaId" element={<MemberProfilePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
